
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { GetAudioText, GetTextAudio, UploadFileToOSS } from "@/request/common";

@Component({
  components: {},
})
export default class AskQuestion extends Vue {
  @Prop()
  private sheAudioUrl!: string;
  @Prop({ required: true })
  private deepseekResult!: string;
  @Watch("deepseekResult", { immediate: true })
  private async deepseekResultChange(newVal: string) {
    if (newVal) {
      // await this.playCountdown(newVal);
      // this.showTool = true;
      // const audio = new Audio(newVal);
      // audio.play();
      // // 监听音频播放结束事件
      // audio.addEventListener("ended", () => {
      //   this.showTool = true;
      // });
    }
  }
  @Prop({ required: true })
  private imageUrl!: string;
  private isRecording = false;
  private mediaRecorder: any = null;
  private audioBlob: Blob | null = null;
  private audioChunks: Blob[] = [];
  private audioStream: MediaStream | null = null;
  private audioContext: AudioContext | null = null;
  private analyser: AnalyserNode | null = null;
  private animationFrameId: number | null = null;
  private isProcessing = false;
  private audioText = "";
  private audioUrl!: string;
  private sheAudio: any = "";
  private startShibie = false;
  private showTool: any = false;
  private tiaoguo() {
    if (this.sheAudioUrl) {
      console.log("发出停止指令");
      this.$emit("stopAudio");
    }
    this.audioText = "无";
    this.goReport();
  }
  private async getTextAudio(text: string): Promise<string> {
    return new Promise((resolve, reject) => {
      GetTextAudio(this, {
        text: text,
      })
        .then((res: any) => {
          const base64Data = res.data;
          const byteCharacters = atob(base64Data);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: "audio/mp3" });
          const url = URL.createObjectURL(blob);
          resolve(url);
        })
        .catch(() => {
          reject();
        });
    });
  }
  private playCountdown(val: any): Promise<void> {
    return new Promise((resolve) => {
      const text = val;
      const utterance = new SpeechSynthesisUtterance(text);

      // 设置中文语音
      const voices = window.speechSynthesis.getVoices();
      const chineseVoice = voices.find((voice) => voice.lang.startsWith("zh"));
      if (chineseVoice) {
        utterance.voice = chineseVoice;
      }

      utterance.onend = () => {
        resolve();
      };

      window.speechSynthesis.speak(utterance);
    });
  }
  private goTakeTongue() {
    this.$emit("goTakeTongue");
  }
  private cancelRecording() {
    this.resetData();
  }
  private resetData() {
    this.isRecording = false;
    this.mediaRecorder = null;
    this.audioBlob = null;
    this.audioChunks = [];
    this.audioStream = null;
    this.audioContext = null;
    this.analyser = null;
    this.animationFrameId = null;
    this.isProcessing = false;
    this.audioText = "";
    this.audioUrl = "";
    this.sheAudio = "";
    this.startShibie = false;
    this.showTool = false;
  }
  private goHome() {
    if (this.sheAudioUrl) {
      console.log("发出停止指令");
      this.$emit("stopAudio");
    }
    this.$router.push("/home");
  }

  private goReport() {
    this.$emit("submitAudio", this.audioText);
  }
  private async startRecording() {
    console.log(this.sheAudioUrl);
    if (this.sheAudioUrl) {
      console.log("发出停止指令");
      this.$emit("stopAudio");
    }
    if (this.isProcessing) return;

    // 先调用getTextAudio播放提示语音
    // try {
    //   console.log("开始播放提示语音...");
    //   const audioUrl = await this.getTextAudio("请问您最近还有哪里不舒服，具体症状是什么？");

    //   // 播放提示语音
    //   const audio = new Audio(audioUrl);
    //   await new Promise((resolve, reject) => {
    //     audio.addEventListener('ended', resolve);
    //     audio.addEventListener('error', reject);
    //     audio.play();
    //   });

    //   console.log("提示语音播放完成，开始录音");
    // } catch (error) {
    //   console.error("播放提示语音失败:", error);
    //   this.$toast.fail("播放提示语音失败");
    //   return;
    // }

    // 提示语音播放完成后，开始录音
    this.isProcessing = true;

    try {
      this.audioChunks = [];
      this.audioStream = await navigator.mediaDevices.getUserMedia({
        audio: {
          sampleRate: 16000, // 指定采样率
          channelCount: 1, // 单声道
        },
      });

      // 配置MediaRecorder参数
      const options = {
        audioBitsPerSecond: 16000,
        mimeType: "audio/webm;codecs=opus",
      };

      this.mediaRecorder = new MediaRecorder(this.audioStream, options);

      // 初始化音频分析上下文
      this.audioContext = new (window.AudioContext ||
        (window as any).webkitAudioContext)();
      const source = this.audioContext.createMediaStreamSource(
        this.audioStream
      );
      this.analyser = this.audioContext.createAnalyser();
      source.connect(this.analyser);
      this.analyser.fftSize = 256;

      // 数据收集处理
      this.mediaRecorder.ondataavailable = (e: BlobEvent) => {
        this.audioChunks.push(e.data);
      };

      // 录音停止处理
      this.mediaRecorder.onstop = () => {
        this.audioBlob = new Blob(this.audioChunks, {
          type: options.mimeType,
        });
        this.audioUrl = URL.createObjectURL(this.audioBlob);
        this.cleanupStream();
      };

      // 错误处理
      this.mediaRecorder.onerror = (e: Event) => {
        this.$toast.fail("录音错误: " + (e as any).error);
        this.cleanupStream();
      };

      this.mediaRecorder.start(100); // 每100ms收集一次数据
      this.isRecording = true;
    } catch (error) {
      this.$toast.fail("麦克风访问失败: " + (error as Error).message);
      console.error("Recording Error:", error);
    } finally {
      this.isProcessing = false;
    }
  }

  private stopRecording() {
    console.log("结束问诊");
    this.startShibie = true;
    if (this.mediaRecorder) {
      this.mediaRecorder.stop();
      this.isRecording = false;
    }
    setTimeout(() => {
      this.submitAudio();
    }, 1000);
  }

  private reRecord() {
    this.audioBlob = null;
    this.audioUrl = "";
    this.startRecording();
  }

  private async submitAudio() {
    console.log("语音识别");
    try {
      // 添加空值检查
      if (!this.audioBlob) {
        this.$toast.fail("音频数据为空，请重新录制");
        return;
      }

      // 转换webm为wav
      const wavBlob = await this.convertWebmToWav(this.audioBlob);

      // 创建FormData对象上传到OSS
      const formData = new FormData();
      formData.append("upload_file", wavBlob, "audio.wav");

      console.log("开始上传音频文件到OSS");
      // 先上传音频文件到OSS获取URL
      const uploadResult = await UploadFileToOSS(this, formData);
      console.log("音频文件上传成功:", uploadResult);

      // 获取音频文件URL
      const speechUrl = uploadResult.file_url;

      console.log("开始调用GetAudioText接口");
      // 调用GetAudioText接口，传递speech_url参数
      const audioTextResult = await GetAudioText(this, {
        speech_url: speechUrl,
      });

      console.log("语音识别结果:", audioTextResult);
      this.startShibie = false;
      this.audioText = audioTextResult.result.text;
    } catch (error) {
      this.$toast.fail("语音识别失败");
      this.resetData();
      console.error(error);
    }
  }

  private async recognizeAudio(arrayBuffer: ArrayBuffer): Promise<string> {
    return new Promise((resolve, reject) => {
      const url = "ws://jvpegjcvoors.sealosgzg.site/api/websocket2/doubao2";
      const ws = new WebSocket(url);

      ws.onopen = () => {
        console.log("WebSocket连接成功");
        // 发送配置参数
        ws.send(
          JSON.stringify({
            type: "START",
            audio_format: "audio/webm;codecs=opus",
            sample_rate: 16000,
            enable_punctuation: true,
          })
        );

        // 一次性发送整个音频数据
        console.log("发送音频数据");
        ws.send(arrayBuffer);

        // 发送结束帧
        console.log("发送结束");
        ws.send(JSON.stringify({ type: "END" }));
      };

      ws.onmessage = (event) => {
        console.log("收到API响应:", event.data);
        try {
          const data = JSON.parse(event.data);
          console.log("解析后的数据:", data);

          if (data.code === 20000000) {
            resolve(data.result.text);
          } else {
            reject(new Error(`[${data.code}] ${data.message}`));
          }
        } catch (e) {
          console.error("解析API响应失败:", e);
          reject(new Error("无效的API响应"));
        } finally {
          ws.close();
        }
      };

      ws.onerror = (error) => {
        console.error("WebSocket连接错误:", error);
        reject(new Error("WebSocket连接失败"));
        ws.close();
      };

      ws.onclose = () => {
        // 关闭连接时的清理操作
      };
    });
  }

  private blobToArrayBuffer(blob: Blob): Promise<ArrayBuffer> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as ArrayBuffer);
      reader.onerror = () => reject(reader.error);
      reader.readAsArrayBuffer(blob);
    });
  }

  private stopVisualizer() {
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId);
      this.animationFrameId = null;
    }
  }

  private cleanupStream() {
    if (this.audioStream) {
      this.audioStream.getTracks().forEach((track) => track.stop());
      this.audioStream = null;
    }
    if (this.audioContext) {
      this.audioContext.close();
      this.audioContext = null;
    }
  }

  beforeDestroy() {
    this.cleanupStream();
    this.stopVisualizer();
    if (this.audioUrl) {
      URL.revokeObjectURL(this.audioUrl);
    }
  }

  private async convertWebmToWav(webmBlob: Blob): Promise<Blob> {
    console.log("开始转换webm为wav");
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = async () => {
        console.log("webm文件读取完成");
        const arrayBuffer = reader.result as ArrayBuffer;

        // 使用AudioContext解码webm
        const audioContext = new (window.AudioContext ||
          (window as any).webkitAudioContext)();
        try {
          console.log("开始解码webm");
          const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
          console.log("webm解码完成");

          // 创建WAV文件
          const wavBlob = this.encodeWav(audioBuffer);
          console.log("wav文件创建完成");
          resolve(wavBlob);
        } catch (error) {
          console.error("webm解码失败:", error);
          reject(error);
        } finally {
          audioContext.close();
        }
      };
      reader.onerror = () => {
        console.error("文件读取失败:", reader.error);
        reject(reader.error);
      };
      reader.readAsArrayBuffer(webmBlob);
    });
  }

  private encodeWav(audioBuffer: AudioBuffer): Blob {
    const numChannels = audioBuffer.numberOfChannels;
    const sampleRate = audioBuffer.sampleRate;
    const length = audioBuffer.length * numChannels * 2;
    const buffer = new ArrayBuffer(44 + length);
    const view = new DataView(buffer);

    // 写入WAV文件头
    this.writeString(view, 0, "RIFF");
    view.setUint32(4, 36 + length, true);
    this.writeString(view, 8, "WAVE");
    this.writeString(view, 12, "fmt ");
    view.setUint32(16, 16, true);
    view.setUint16(20, 1, true);
    view.setUint16(22, numChannels, true);
    view.setUint32(24, sampleRate, true);
    view.setUint32(28, sampleRate * numChannels * 2, true);
    view.setUint16(32, numChannels * 2, true);
    view.setUint16(34, 16, true);
    this.writeString(view, 36, "data");
    view.setUint32(40, length, true);

    // 写入音频数据
    this.floatTo16BitPCM(view, 44, audioBuffer);

    return new Blob([view], { type: "audio/wav" });
  }

  private writeString(view: DataView, offset: number, string: string) {
    for (let i = 0; i < string.length; i++) {
      view.setUint8(offset + i, string.charCodeAt(i));
    }
  }

  private floatTo16BitPCM(
    view: DataView,
    offset: number,
    audioBuffer: AudioBuffer
  ) {
    for (let i = 0; i < audioBuffer.numberOfChannels; i++) {
      const channel = audioBuffer.getChannelData(i);
      for (let j = 0; j < channel.length; j++) {
        const s = Math.max(-1, Math.min(1, channel[j]));
        view.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7fff, true);
        offset += 2;
      }
    }
  }
  private mounted() {}
}
